<template>
  <div>
    <v-snackbar :color="notification.type"
                bottom left :value="notification.show" @input="input"
                v-for="(notification, index) in notifications" :key="index">
      {{notification.message}}
      <v-btn flat @click.native="close"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Vuex from 'vuex'

const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'notification',
  computed: {
    ...dialogsStore.mapState({
      notifications: 'notifications'
    })
  },
  methods: {
    ...dialogsStore.mapActions({
      closeNotification: 'closeNotification'
    }),
    close () {
      // this.$emit('close')
      this.closeNotification()
    },
    input (value) {
      if (!value) {
        this.closeNotification()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/Notification.vue